var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "row align-items-start" }, [
    _c(
      "div",
      {
        staticClass: "col-md-9 col-12 row dashboard-group justify-content-start"
      },
      [
        _c("Earnings"),
        _vm._v(" "),
        _c("Claims"),
        _vm._v(" "),
        _c("Refunds"),
        _vm._v(" "),
        _c("BooksSource"),
        _vm._v(" "),
        _c("BooksTags"),
        _vm._v(" "),
        _c("CanceledOnHoldJobs"),
        _vm._v(" "),
        _c("Summary"),
        _vm._v(" "),
        _c("TopCompanies")
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-3 col-12 row dashboard-group" },
      [_c("RecentReviews")],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-99ed9a18", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99ed9a18","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/salesDashboard/SalesDashboard.vue
// module id = null
// module chunks = 